import "./RaceSelectionCard.css";
import React, { useMemo, useState } from "react";
import { IRpgRace } from "../../models/IRpgRace";

export interface IRaceSelectionCardProps {
    race: IRpgRace;
    isSelected: boolean;
    isDisabled?: boolean;
    gender?: string;
    onSelect: (race: IRpgRace) => void;
}

const RaceSelectionCard: React.FC<IRaceSelectionCardProps> = ({ race, isSelected, isDisabled = false, gender, onSelect, }) => {
    const [hasImageError, setHasImageError] = useState(false);

    const imgSrc = useMemo(() => {
        const g = (gender && gender.trim().length > 0) ? gender.trim().toLowerCase() : "male";
        const key = race.Image && race.Image.trim().length > 0 ? race.Image.trim().toLowerCase() : "";
        if (key.length === 0) {
            return "";
        }

        return `/images/Races/${g}-${key}.png`;
    }, [gender, race.Image]);

    const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (isDisabled) {
            return;
        }

        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onSelect(race);
        }
    };

    return (
        <div
            className={`race-card${isSelected ? " is-selected" : ""}${isDisabled ? " is-disabled" : ""}`}
            onClick={isDisabled ? undefined : () => onSelect(race)}
            role="button"
            tabIndex={0}
            onKeyDown={onKeyDown}
        >
            <div className="race-card__thumb">
                {!hasImageError && imgSrc ? (
                    <img
                        className="race-card__img"
                        src={imgSrc}
                        alt={race.Name}
                        onError={() => setHasImageError(true)}
                    />
                ) : (
                    <div className="race-card__img-fallback" aria-hidden="true" />
                )}
            </div>

            <div className="race-card__content">
                <div className="race-card__title">{race.Name}</div>
                <div className="race-card__subtitle">{race.Description}</div>
            </div>
        </div>
    );
};

export default RaceSelectionCard;
